import React from 'react';
import BN from 'bignumber.js';
import { useSelector, useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import stylesParent from '../../../styles/frame/frame.module.scss';
import styles from '../../../styles/unstake/unstake-details.module.scss';
import ClaimBg from '../../../../../../../assets/images/LIGHT_CLAIM_ILLUSTRATION.svg';
import Header from '../../../../../../../components/Stake/header';
import { useGetTheme } from '../../../../../../../hooks/useGetTheme';
import { formatToken } from '../../../../../../../helpers/token-helper';

import AlphaEthUniIcon from '../../../../../../../assets/images/ALPHA_ETH.svg';
import * as alphaEthUniStakeActions from '../../../../../../../actions/alpha-eth-uni-stake-actions';

const ClaimDetails = () => {
  const dispatch = useDispatch();
  const colors = useGetTheme();
  const { rewardBalance, rewardEarned } = useSelector((state) => state.ALPHAETHUNIstake.stake);

  const amount = formatToken(new BN(rewardBalance).plus(rewardEarned).toString(10), 10);

  return (
    <>
      <Header
        icon={AlphaEthUniIcon}
        title='IMPACT/ETH-Staking'
        onClickBack={() => dispatch(alphaEthUniStakeActions.stakeReset())}
      />
      <div className={stylesParent.cardContent} style={{ color: colors.text }}>
        <div className={styles.title}>You Are Claiming</div>
        <div className={styles.value}>{amount} BCUBE</div>
        <img className={styles.image} src={ClaimBg} alt='' />
        <div>
          <div className={styles.descriptionItem}>
            <span>*</span> There is an 8 day claiming period before you are able to withdraw your
            unclaimed tokens. Following that 8 day unclaiming period, users will be able to withdraw
            their rewards.
          </div>
        </div>
        <div className={stylesParent.cardFooterControls}>
          <Button
            onClick={() => dispatch(alphaEthUniStakeActions.claimRewardsSend(amount))}
            variant='contained'
            color='secondary'
            className={stylesParent.cardFooterControlsButton}
          >
            Claim Rewards
          </Button>
        </div>
      </div>
    </>
  );
};

export default ClaimDetails;
